import { css } from "styled-components";

import { colorCSS } from "./colors";
import { radius } from "./radius";
import { redundantCssFromKebab } from "./redundant-css";

export const formCSS: ReturnType<typeof css> = css`
    input,
    select,
    textarea,
    button[type="submit"] {
        ${redundantCssFromKebab("background", `${colorCSS("N20")}`)}
        ${redundantCssFromKebab("border", `1px solid ${colorCSS("N40")}`)}
        ${redundantCssFromKebab("border-radius", `${radius.small}`)}
        ${redundantCssFromKebab("margin-block-end", "0.75rem")}
        ${redundantCssFromKebab("padding", "0.4rem 0.8rem")}
        ${redundantCssFromKebab("width", "100%")}
        ${redundantCssFromKebab("transition", "250ms ease-out")}
        &:focus {
            ${redundantCssFromKebab("border-color", `${colorCSS("B300", 0.5)}`)}
            ${redundantCssFromKebab(
                "box-shadow",
                `0 0 0 3px ${colorCSS("B300", 0.15)}`
            )}
            ${redundantCssFromKebab("outline", "none")}
        }
    }
    select {
        ${redundantCssFromKebab("appearance", "none")}
    }
    textarea {
        ${redundantCssFromKebab("min-height", "6.25rem")}
    }
    button[type="submit"] {
        ${redundantCssFromKebab("background-color", `${colorCSS("B300")}`)}
        ${redundantCssFromKebab("border", `1px solid ${colorCSS("B300")}`)}
        ${redundantCssFromKebab("border-radius", `${radius.button}`)}
        ${redundantCssFromKebab("color", `${colorCSS("N0")}`)}
        ${redundantCssFromKebab("margin-block-start", "0.5rem")}
        ${redundantCssFromKebab("padding", "0.7rem 1rem 0.8rem")}
        ${redundantCssFromKebab("width", "auto")}
        &:hover {
            ${redundantCssFromKebab("background-color", `${colorCSS("B400")}`)}
            ${redundantCssFromKebab("border-color", `${colorCSS("B400")}`)}
        }
        &:active {
            ${redundantCssFromKebab("background-color", `${colorCSS("B500")}`)}
            ${redundantCssFromKebab("border-color", `${colorCSS("B500")}`)}
        }
        &:focus {
            ${redundantCssFromKebab(
                "box-shadow",
                `0 0 0 0.2rem ${colorCSS("B400", 0.5)}`
            )}
        }
    }
`;
